import EmptyDataTable from '@components/EmptyDataTable/EmptyDataTable';
import { ConfigProvider, Table } from 'antd';
import { TableRowSelection } from 'antd/es/table/interface';
import { TableListWrapper } from './TableListStyled';

type TTableListProps = {
  rowKey: number | null;
  /** Field name antd Table uses as the unique row identifier. Defaults to 'key'. */
  rowKeyField?: string;
  listData: any[];
  messageNoData: string;
  columns?: any[];
  heightTableScroll: number;
  handleScroll: (e: any) => void;
  borderColor: string;
  image: string;
  tableRef: any;
  rowSelection?: TableRowSelection<any>;
};

function TableList(props: TTableListProps) {
  const {
    columns,
    handleScroll,
    heightTableScroll,
    listData,
    messageNoData,
    rowKey,
    rowKeyField = 'key',
    borderColor,
    image,
    tableRef,
    rowSelection,
  } = props;

  return (
    <TableListWrapper listdata={listData.length}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: 'var(--background-header-table)',
              borderColor,
              rowHoverBg: 'var(--color-row-hover)',
              headerColor: 'var(--color-header-table)',
              fontWeightStrong: 700,
            },
          },
        }}
        renderEmpty={() =>
          !listData.length ? (
            <EmptyDataTable image={image} message={messageNoData} />
          ) : undefined
        }
      >
        <Table
          ref={tableRef}
          dataSource={listData}
          columns={columns}
          pagination={false}
          virtual={listData.length > 0}
          scroll={{ y: heightTableScroll }}
          onScroll={handleScroll}
          bordered
          rowKey={rowKeyField}
          rowSelection={rowSelection}
          rowClassName={(record) => {
            return rowKey === record[rowKeyField] ? 'row_active' : '';
          }}
        />
      </ConfigProvider>
    </TableListWrapper>
  );
}

export { TableList };
